module.exports = __webpack_public_path__ + "img/img4.f22d517d.png";